import { ENV } from '../config/env';

/**
 * Cliente del daemon local de firma (#59, F1B-7).
 *
 * Consulta GET {daemon}/status para conocer la versión INSTALADA del cliente. Es
 * best-effort: si el daemon no está corriendo o no está instalado, devolvemos null y la
 * feature simplemente no avisa. Canal HTTP loopback (ADR-035: http://127.0.0.1:12555, sin
 * cert). No lleva token (es loopback, sin auth) ni pasa por el axios autenticado de la API.
 */
const DEFAULT_TIMEOUT_MS = 2000;

/**
 * @returns {Promise<{version: string|null, raw: object}|null>} null ante cualquier fallo.
 */
export const getLocalClientStatus = async (timeoutMs = DEFAULT_TIMEOUT_MS) => {
  const base = ENV.SIGNATURE_CLIENT_DAEMON_URL;
  if (!base) return null;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(`${base.replace(/\/+$/, '')}/status`, {
      method: 'GET',
      mode: 'cors',
      signal: controller.signal,
    });
    if (!res.ok) return null;
    const raw = await res.json();
    return { version: raw?.version || null, raw };
  } catch (_e) {
    // Daemon caído / no instalado / cert no confiable / CORS → no podemos determinar versión.
    return null;
  } finally {
    clearTimeout(timer);
  }
};

export default getLocalClientStatus;
